import React from 'react'
import { Container, Row, Col } from 'reactstrap'

import MonthlyConsumptionGraph from './MonthlyConsumptionGraph'
import MonthlyConsumptionOptions from './MonthlyConsumptionOptions'

const MonthlyConsumption = ({ title }) => {
  return (
    <Container className="box">
      <Row>
        <Col>
          <h3>{title}</h3>
        </Col>
      </Row>
      <Row>
        <Col xs="10" className="graph-container">
          <MonthlyConsumptionGraph />
        </Col>
        <Col xs="2">
          <MonthlyConsumptionOptions />
        </Col>
      </Row>
    </Container>
  )
}

export default MonthlyConsumption
